
import React from 'react'
import ImageList from './ImageList'; // Adjust the import path as necessary

export default function ChatMedia({ media }) {
  const file = media[0];
  const fileUrl = `${process.env.REACT_APP_API_URL}/${file.filePath}`;

  if (["image/jpeg", "image/png"].includes(file.fileType)) {
    return <ImageList images={media} />;
  }

  if (file.fileType === "audio/webm") {
    return (
      <audio controls>
        <source src={fileUrl} type="audio/webm" />
        Your browser does not support the audio element.
      </audio>
    );
  }

  return (
    <div className="flex justify-between items-center">
      <span className="text-md text-grey-800">{file.fileName}</span>
      <a className="px-2" href={fileUrl} download>
        <i className="ri-download-cloud-2-line text-xl" style={{ marginTop: 4 }}></i>
      </a>
    </div>
  );
}
